import * as THREE from "three"

/**
 * Fábricas PURAS de materiales THREE para los overlays del visor (carriles de
 * avance y resaltado). Sin estado de componente, sin escena: solo crean el
 * material a partir de un color. El caller los guarda y dispone. Primer paso de
 * la extracción del render (overlay) fuera del god component.
 */

/**
 * Material reutilizable por color para los carriles de avance. Opacidad alta
 * (0.9) para que el color del status domine sobre el ribbon gris del DxfViewer
 * y no se vea "fusionado" con éste. Guarda el color base en userData para poder
 * restaurarlo tras un dim (ver _DimAdvanceGroup).
 * @param {number} colorInt
 * @returns {THREE.MeshBasicMaterial}
 */
export function makeAdvanceMaterial(colorInt) {
  const mat = new THREE.MeshBasicMaterial({
    color:       colorInt,
    transparent: true,
    opacity:     0.9,
    depthTest:   false,
    depthWrite:  false,
    side:        THREE.DoubleSide,
  })
  mat.userData.baseColorHex = colorInt
  return mat
}

/**
 * Relleno del resaltado: color chillante y SÓLIDO (sin translucidez) para que
 * salte a la vista. El borde brillante lo remarca aún más.
 * @param {number} colorInt
 * @returns {THREE.MeshBasicMaterial}
 */
export function makeHighlightMaterial(colorInt) {
  return new THREE.MeshBasicMaterial({
    color:       colorInt,
    transparent: true,   // se mantiene en el pase transparente (respeta renderOrder vs avance)
    opacity:     1,      // pero totalmente sólido a la vista
    depthTest:   false,
    depthWrite:  false,
    side:        THREE.DoubleSide,
  })
}

/**
 * Borde del resaltado: MISMO color que el relleno (línea uniforme, sin rim
 * aclarado), sólido para remarcar los cantos de la polilínea.
 * @param {number} colorInt
 * @returns {THREE.MeshBasicMaterial}
 */
export function makeHighlightEdgeMaterial(colorInt) {
  return new THREE.MeshBasicMaterial({
    color:       colorInt,
    transparent: true,
    opacity:     1,
    depthTest:   false,
    depthWrite:  false,
    side:        THREE.DoubleSide,
  })
}
